import {
  InviteToApplyPayload,
  InviteToApplyResponse,
} from 'features/Connect/features/ConnectATSIntegration/InviteToApply/types';
import { BaseNimbleAPI } from './baseAPI';

class InviteToApplyAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/hiring-requests' };
  }

  async inviteToApply(payload: InviteToApplyPayload): Promise<InviteToApplyResponse> {
    const response = await this.post('/invite-to-apply/', payload);
    return response.data;
  }
}

export default new InviteToApplyAPI();
